import { jsonArrayMember, jsonMember, jsonObject } from 'typedjson';
import { Guid, Nillable } from '@web/utils';
import { AdminBoxContextOperationsResponse } from './admin-box-context-operations.response';
import { MultimediaResponse } from '@web/shared/module/multimedia';
import { AdminBoxStatus } from '../../enums/admin-box-status';
import { AdminBoxCosmeticBrandResponse } from './admin-box-cosmetic-brand.response';
import { DictionaryResponse } from '@web/shared/module/dictionary';
import { AdminBoxCharacteristicResponse } from './admin-box-characteristic.response';
import { AdminBoxAttributeResponse } from './admin-box-attribute.response';
import { AdminBoxCosmeticResponse } from './admin-box-cosmetic.response';
import { AdminBoxWarehouseProductResponse } from './admin-box-warehouse-product.response';

@jsonObject
export class AdminBoxDetailsResponse {
  @jsonMember(String)
  public readonly id!: Guid;

  @jsonMember(String)
  public readonly name!: string;

  @jsonMember(String)
  public readonly slug!: string;

  @jsonMember(String)
  public readonly password?: Nillable<string>;

  @jsonMember(Number)
  public readonly price!: number;

  @jsonMember(Number)
  public readonly maxQuantityPerOrder?: Nillable<number>;

  @jsonMember(Number)
  public readonly availableQuantity?: Nillable<number>;

  @jsonMember(String)
  public readonly contentPreviewUrl?: Nillable<string>;

  @jsonMember(Boolean)
  public readonly currentEdition?: Nillable<boolean>;

  @jsonMember(String)
  public readonly status!: AdminBoxStatus;

  @jsonMember(Date)
  public readonly createdAt!: Date;

  @jsonMember(Date)
  public readonly publishedAt?: Nillable<Date>;

  @jsonMember(AdminBoxCosmeticBrandResponse)
  public readonly cosmeticBrand?: Nillable<AdminBoxCosmeticBrandResponse>;

  @jsonMember(DictionaryResponse)
  public readonly category?: Nillable<DictionaryResponse>;

  @jsonMember(AdminBoxWarehouseProductResponse)
  public readonly warehouseGood?: Nillable<AdminBoxWarehouseProductResponse>;

  @jsonMember(MultimediaResponse)
  public readonly featuredFile?: Nillable<MultimediaResponse>;

  @jsonMember(MultimediaResponse)
  public readonly symbolFile?: Nillable<MultimediaResponse>;

  @jsonMember(MultimediaResponse)
  public readonly illustrationFile?: Nillable<MultimediaResponse>;

  @jsonMember(AdminBoxContextOperationsResponse)
  public readonly contextOperations!: AdminBoxContextOperationsResponse;

  @jsonArrayMember(MultimediaResponse)
  public readonly files?: Nillable<MultimediaResponse[]>;

  @jsonArrayMember(AdminBoxCharacteristicResponse)
  public readonly characteristics?: Nillable<AdminBoxCharacteristicResponse[]>;

  @jsonArrayMember(AdminBoxAttributeResponse)
  public readonly attributes?: Nillable<AdminBoxAttributeResponse[]>;

  @jsonArrayMember(AdminBoxCosmeticResponse)
  public readonly cosmetics?: Nillable<AdminBoxCosmeticResponse[]>;
}
